import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { withRouter } from 'react-router-dom';

import { Grid } from '../../components';
import {
    categoriaService,
    Utils,
} from '../../services';

class InscricaoStepCategoria extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsCategorias: [],
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        await this.buscarCategorias();
    }

    async buscarCategorias() {
        const categorias = await categoriaService.getCategorias(this.props.subevento);
        this.setState({ dsCategorias: categorias });
        Utils.showLoading(false);
    }

    async buscarCategoriasPushRouter(categoria) {
        this.props.onSelecionarCategoria(categoria);
    }

    render() {
        const {
            dsCategorias,
        } = this.state;

        return (
            <Grid
                columnSortDefault={0}
                textTableEmpty="Não há categorias para este evento."
                showSearch={false}
                dataSource={dsCategorias}
                columns={[
                    {
                        text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                    },
                    {
                        text: 'Descrição', name: 'DESCRICAO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                    },
                    {
                        name: item => (
                            <div style={{ textAlign: 'center' }}>
                                <RaisedButton onClick={() => this.buscarCategoriasPushRouter(item.CODIGO)} label="AVANÇAR" primary />
                            </div>
                        ),
                    },
                ]}
            />
        );
    }
}

InscricaoStepCategoria.propTypes = {
    onSelecionarCategoria: PropTypes.func.isRequired,
    subevento: PropTypes.number.isRequired,
};

export default withRouter(InscricaoStepCategoria);
